<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      class="animate-draw-circle stroke-current"
      stroke-width="2"
      pathLength="1"
      stroke-dasharray="1"
      stroke-dashoffset="1"
    />
    <path
      d="M 7 12.5 L 10.5 16 L 17 9"
      class="animate-draw-check stroke-current"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      pathLength="1"
      stroke-dasharray="1"
      stroke-dashoffset="1"
    />
  </svg>
</template>
